module.exports = {"content":{"links":["home","quoting","service","pricing","business","about","faq","contact","legal","faq"],"languages":{"en_sg":"en_sg"}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/sg/setting/sitemap/setting.json
// module id = 719
// module chunks = 0 1 2 3 4 5